/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBatteryExclametionMark: {
  name: 'battery-exclametion-mark';
  data: string;
} = {
  name: 'battery-exclametion-mark',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h3a1 1 0 1 0 0-2H4V8h3a1 1 0 0 0 0-2H4Zm11 0a1 1 0 1 0 0 2h2v8h-2a1 1 0 1 0 0 2h2a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-2Zm-3 1a1 1 0 1 0-2 0v6a1 1 0 1 0 2 0V7Zm10 2a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Zm-11 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" fill="currentColor"/></svg>`,
};
